export const LINK_CAREERS = 'https://careers.devsisters.com';
export const LINK_GITHUB = 'https://github.com/devsisters';
export const LINK_DEVTECH_YOUTUBE = 'https://www.youtube.com/@DEVSISTERS_TECH';
export const LINK_YOUTUBE = 'https://youtube.com/@devsisters';
export const LINK_X = 'https://x.com/devsisters';
export const LINK_LINKED_IN = 'https://linkedin.com/company/devsisters';

// XXX(inseopkim): WSC-3471
// 정책 페이지 문제로, 언어 미포함 주소를 사용하면 무조건 이용약관 페이지로 이동되는 문제가 있음.
// 다국어 미대응이라 한국어 고정 주소를 사용
export const LINK_PARENTAL_GUIDE = 'https://policy.devsisters.com/ko/parental-guide';
export const LINK_PRIVACY_POLICY = 'https://policy.devsisters.com/ko/privacy';
export const LINK_TERMS_OF_SERVICE = 'https://policy.devsisters.com/ko/terms-of-service';
